import './static/style.scss';
import './game/main';


try {
  require('./tg-integration')
} catch {}